import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { IntegrationCatalog } from "@modules/erpIntegrations/types";

import { ListIntegrationsQueryFilters } from "./types";

export async function getIntegrationsService(
  filters?: ListIntegrationsQueryFilters
): Promise<IntegrationCatalog[]> {
  const { data } = await api.get<ApiResponse<IntegrationCatalog>>(
    "/v1/integration_admin/",
    {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        search: filters?.search,
        name: filters?.name,
        active: filters?.active,
      },
    }
  );

  return data.results;
}
